<template>
  <section id="apply-bank">
    <b-table class="mb-1" striped hover :fields="fields" :items="items">
      <template #cell(GINKO_MEI)="data">
        <validation-provider
          v-slot="{ errors, touched }"
          :rules="`${!isInput(data.index) ? 'required|' : ''}max:20|char`"
          :name="`GINKO_MEI${data.index}`"
        >
          <div v-if="isMobile" class="sp-label pl-2"><b>銀行名</b></div>
          <b-form-input
            v-model="items[data.index].GINKO_MEI"
            :ref="`GINKO_MEI${data.index}`"
            maxlength="20"
            :state="errors.length ? false : null"
            placeholder="〇〇銀行"
            trim
            @blur="
              items[data.index].GINKO_MEI = replaceChar(
                items[data.index].GINKO_MEI
              )
            "
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </template>

      <template #cell(SHITEN_MEI)="data">
        <validation-provider
          v-slot="{ errors }"
          :rules="`${!isInput(data.index) ? 'required|' : ''}max:20|char`"
          :name="`SHITEN_MEI${data.index}`"
        >
          <div v-if="isMobile" class="sp-label pl-2"><b>支店名</b></div>
          <b-form-input
            v-model="items[data.index].SHITEN_MEI"
            :ref="`SHITEN_MEI${data.index}`"
            maxlength="20"
            :state="errors.length ? false : null"
            placeholder="〇〇支店"
            trim
            @blur="
              items[data.index].SHITEN_MEI = replaceChar(
                items[data.index].SHITEN_MEI
              )
            "
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </template>

      <template #cell(KOUZA_SYUBETU)="data">
        <validation-provider
          v-slot="{ errors }"
          :rules="`${!isInput(data.index) ? 'required|' : ''}`"
          :name="`KOUZA_SYUBETU${data.index}`"
        >
          <b-form-select
            v-model="items[data.index].KOUZA_SYUBETU"
            :ref="`KOUZA_SYUBETU${data.index}`"
            :state="errors.length ? false : null"
            :options="kouzaSyubetuList"
            trim
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </template>

      <template #cell(KOUZA_BANGO)="data">
        <validation-provider
          v-slot="{ errors }"
          :rules="`${!isInput(data.index) ? 'required|' : ''}max:8|numeric`"
          :name="`KOUZA_BANGO${data.index}`"
        >
          <div v-if="isMobile" class="sp-label pl-2"><b>口座番号</b></div>
          <b-form-input
            v-model="items[data.index].KOUZA_BANGO"
            :ref="`KOUZA_BANGO${data.index}`"
            maxlength="8"
            :state="errors.length ? false : null"
            placeholder="0000001"
            trim
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </template>

      <template #cell(MEIGININ)="data">
        <validation-provider
          v-slot="{ errors }"
          :rules="`${
            !isInput(data.index) ? 'required|' : ''
          }max:20|hanKatakana`"
          :name="`MEIGININ${data.index}`"
        >
          <div v-if="isMobile" class="sp-label pl-2"><b>名義人</b></div>
          <b-form-input
            v-model="items[data.index].MEIGININ"
            :ref="`MEIGININ${data.index}`"
            maxlength="20"
            :state="errors.length ? false : null"
            placeholder="ｶ)ﾛｼﾞｺ"
            trim
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </template>

      <template #cell()="data">
        <b-button
          @click="deleteItem(data.index)"
          :disabled="items.length === 1"
        >
          削除
        </b-button>
      </template>
    </b-table>
    <div>
      <b-button variant="info" @click="addItem">追加</b-button>
    </div>
  </section>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Constant from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'

const GINKO = {
  GINKO_MEI: null,
  SHITEN_MEI: null,
  KOUZA_SYUBETU: null,
  KOUZA_BANGO: null,
  MEIGININ: null,
}
export default {
  name: 'Bank',

  mixins: [Mixin],

  props: {
    /** データ取得フラグ */
    isGetData: {
      type: Boolean,
      default: false,
    },

    /** オブザーバー */
    observer: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    test: null,

    fields: [
      { key: 'GINKO_MEI', label: '銀行名' },
      { key: 'SHITEN_MEI', label: '支店名' },
      { key: 'KOUZA_SYUBETU', label: '口座種別' },
      { key: 'KOUZA_BANGO', label: '口座番号' },
      { key: 'MEIGININ', label: '名義人' },
      '　',
    ],

    /** 口座種別 */
    kouzaSyubetuList: [
      { value: null, text: '未選択' },
      { value: '普通', text: '普通' },
      { value: '当座', text: '当座' },
    ],

    /** 入力データ */
    items: [],
  }),

  mounted() {
    this.addItem()
  },

  methods: {
    /** レコードを追加する */
    async addItem() {
      this.items.push(_.cloneDeep(GINKO))
      await this.sleep(50)
      // observerに追加レコードを認識させる
      const i = this.items.length - 1
      const obs = this.observer.refs
      obs[`GINKO_MEI${i}`].validate()
      obs[`SHITEN_MEI${i}`].validate()
      obs[`KOUZA_SYUBETU${i}`].validate()
      obs[`KOUZA_BANGO${i}`].validate()
      obs[`MEIGININ${i}`].validate()
    },

    /** レコードを削除する */
    deleteItem(i) {
      this.items = this.items.filter((v, i2) => i !== i2)
    },

    /** レコードの全項目が入力されているか、全項目空であればOK */
    isInput(i) {
      const d = this.items[i]
      return (
        (d.GINKO_MEI &&
          d.SHITEN_MEI &&
          d.KOUZA_SYUBETU &&
          d.KOUZA_BANGO &&
          d.MEIGININ) ||
        (!d.GINKO_MEI &&
          !d.SHITEN_MEI &&
          !d.KOUZA_SYUBETU &&
          !d.KOUZA_BANGO &&
          !d.MEIGININ)
      )
    },
  },

  computed: {
    /** バリデーション実行済みか */
    isVlidated() {
      return this.observer && this.observer.flags.validated
    },
  },

  watch: {
    /* データ取得イベント監視 */
    async isGetData(val) {
      if (val)
        this.$emit(
          'setData',
          this.items.filter((v) => v.GINKO_MEI)
        )
    },
  },
}
</script>

<style lang="sass">
@import '../../assets/css/logico2'
#apply-bank
  thead
    color: white
    background: $baseBlueColor
    th:last-child
      width: 85px
  tbody
    .sp-label
      background: $baseBlueColor
      color: white
    td:last-child
      text-align: right
</style>



// WEBPACK FOOTER //
// src/components/apply/Bank.vue